import { render, staticRenderFns } from "./HealthCheck15Register.vue?vue&type=template&id=8b489072&scoped=true&"
import script from "./HealthCheck15Register.vue?vue&type=script&lang=js&"
export * from "./HealthCheck15Register.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck15Register.vue?vue&type=style&index=0&id=8b489072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b489072",
  null
  
)

export default component.exports